export const rmvServices = {
  replaceDriverLicence: {
    en: "Replace driver licence",
    fr: "Replace driver licence"
  },
  renewDriverLicence: {
    fr: "Renew driver licence",
    en: "Renew driver licence"
  },
  nsIDCard: {
    fr: "Nova Scotia ID card",
    en: "Nova Scotia ID card"
  },
  renewLicencePlateStcker: {
    en: "Renew licence plate sticker (vehicle permit renewal)",
    fr: "Renew licence plate sticker (vehicle permit renewal)"
  },
  renewAccessibilityPermit: {
    en: "Renew accessibility permit",
    fr: "Renew accessibility permit"
  },
  registrationAndPlates: {
    en: "Registration and plates (vehicle sale and transfer)",
    fr: "Registration and plates (vehicle sale and transfer)"
  },
  suspendedLicence: {
    en: "Suspended licence",
    fr: "Suspended licence"
  },
  writtenKnowledgeTests: {
    en: "Written knowledge tests (beginners)",
    fr: "Written knowledge tests (beginners)"
  }
};

export const businessCitizenServices = {
  registerRenewBusiness: {
    en: "Register or renew a business",
    fr: "Register or renew a business"
  },
  tenantLandLord: {
    en: "Tenant and Landlord",
    fr: "Tenant and Landlord"
  },
  marriageLicence: {
    en: "Marriage Licence",
    fr: "Marriage Licence"
  }
};

export const locations = {
  amherst: {
    en: "Amherst",
    fr: "Amherst"
  },
  antigonish: {
    en: "Antigonish",
    fr: "Antigonish"
  },
  bridgewater: {
    en: "Bridgewater",
    fr: "Bridgewater"
  },
  darthmouth: {
    en: "Darthmouth",
    fr: "Darthmouth"
  },
  digby: {
    en: "Digby",
    fr: "Digby"
  },
  halifax: {
    en: "Halifax",
    fr: "Halifax"
  },
  kentvile: {
    en: "Kentville",
    fr: "Kentville"
  },
  sackville: {
    en: "Sackville",
    fr: "Sackville"
  },
  middleton: {
    en: "Middleton (RMV office)",
    fr: "Middleton (RMV office)"
  },
  portHawkesbury: {
    en: "Port Hawkesbury",
    fr: "Port Hawkesbury"
  },
  stellarton: {
    en: "Stellarton",
    fr: "Stellarton"
  },
  truro: {
    en: "Truro",
    fr: "Truro"
  },
  yarmouth: {
    en: "Yarmouth",
    fr: "Yarmouth"
  }
};

export const dateTimes = [
  {
    date: "2020-11-10",
    time: ["1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM"]
  },
  {
    date: "2020-11-11",
    time: ["10:00 AM", "11:00 AM", "12:00 PM", "4:00 PM"]
  },
  {
    date: "2020-11-12",
    time: ["10:00 AM", "11:00 AM", "2:00 PM", "3:00 PM"]
  },
  {
    date: "2020-11-13",
    time: ["9:00 AM", "10:00 AM", "4:00 PM", "4:30 PM"]
  },
  {
    date: "2020-11-15",
    time: ["9:00 AM", "10:00 AM", "4:00 PM", "4:30 PM"]
  },
  {
    date: "2020-11-18",
    time: ["9:00 AM", "10:00 AM", "4:00 PM", "4:30 PM"]
  },
  {
    date: "2020-11-19",
    time: ["9:00 AM", "10:00 AM", "4:00 PM", "4:30 PM"]
  },
  {
    date: "2020-11-21",
    time: ["9:00 AM", "10:00 AM", "4:00 PM", "4:30 PM"]
  }
];

export const householdTypeOptions = [
  { id: 1, value: "Single with no kids", valueFrench:"Célibataire sans enfant" },
  { id: 2, value: "Single parent", valueFrench: "Parent seul" },
  { id: 3, value: "Two or more adults(no kids)", valueFrench: "Deux adultes ou plus (sans enfant)" },
  { id: 4, value: "Two or more adults(with kids)", valueFrench: "Deux adultes ou plus (avec enfant)" }
];

export const situationChangeOptions = [
  { id: 1, value: "Widowed",valueFrench: 'Veuvage' },
  { id: 2, value: "Divorced/legally Separated",valueFrench: 'Divorce/séparation' },
  { id: 3, value: "Lost jobs",valueFrench: "Perte d'emploi" },
  { id: 4, value: "Change in custody of kids" ,valueFrench: 'Changement dans la garde des enfants'},
  { id: 5, value: "Other",valueFrench: 'Autre' }
];

export const homeHeatingOptions = [
  { id: 1, value: "Electricity", valueFrench: "Électricité", displayName: "Electricity"},
  { id: 2, value: "Oil", valueFrench: "Mazout", displayName: "Oil"},
  {
    id: 3,
    value: "Propane",
    valueFrench: "Propane",
	 displayName: "Propane"
  },
  {
    id: 4,
    value: "Natural_Gas",
    valueFrench: "Gaz Naturel",
	 displayName: "Natural Gas"
  },
  { id: 5, value: "Wood", valueFrench: "Bois", displayName: "Wood"},
  { id: 6, value: "Wood_pellets", valueFrench: "Granules de bois", displayName: "Wood pellets" },
  { id: 7, value: "Coal", valueFrench: "Charbon", displayName: "Coal"}
];

export const streetShortForms = [
  { name: "street", value: "st" },
  { name: "road", value: "rd" },
  { name: "avenue", value: "av" },
  { name: "drive", value: "dr" },
  { name: "lane", value: "ln" },
  { name: "crescent", value: "cres" },
  { name: "boulevard", value: "blvd" },
  { name: "place", value: "pl" },
  { name: "court", value: "ct" }
];

export const monthOptions = [
  { value: "", english: "Select", french: "Sélectionner" },
  { value: 1, english: "January", french: "janvier" },
  { value: 2, english: "February", french: "février" },
  { value: 3, english: "March", french: "mars" },
  { value: 4, english: "April", french: "avril" },
  { value: 5, english: "May", french: "mai" },
  { value: 6, english: "June", french: "juin" },
  { value: 7, english: "July", french: "juillet" },
  { value: 8, english: "August", french: "août" },
  { value: 9, english: "September", french: "septembre" },
  { value: 10, english: "October", french: "octobre" },
  { value: 11, english: "November", french: "novembre" },
  { value: 12, english: "December", french: "décembre" }
];

export const HOUSE_OWN = "Own";
export const HOUSE_RENT = "Rent";

export const ALLOWED_FILE_TYPES = [".jpeg", ".jpg", ".png", ".gif", ".pdf"];
export const ALLOWED_FILE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "application/pdf"
];
